import { useMemo, UIEvent } from 'react';
import { useTable, useSortBy, useFlexLayout } from 'react-table';
import { Icons } from '../../../components/icons/icons';

type Column = {
  accessor: string;
  Header: string;
  sort?: boolean;
  Cell?: any;
};

type Props = {
  columns: Column[];
  rows: { [key: string]: string | number | boolean }[];
  onUpdate?(item: any): void;
  onDelete?(item: any): void;
  onScrollEnd: () => void;
  isLoading: boolean;
  onRowClick: (item: any) => void;
};

export const Table = (props: Props): JSX.Element => {
  const data = useMemo(() => props.rows, [props.rows]);
  const columns = useMemo(() => props.columns, [props.columns]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data }, useSortBy, useFlexLayout);

  const onScroll = (event: UIEvent): void => {
    const table = event.currentTarget.firstElementChild;
    if (table) {
      const height = event.currentTarget.scrollTop + event.currentTarget.clientHeight;
      if (height + 200 > table.clientHeight) {
        props.onScrollEnd();
      }
    }
  };

  return (
    <div className="new-table-wrapper infinite-scroll-table" onScroll={onScroll}>
      <div {...getTableProps()} className="new-table" style={{ maxWidth: '100%', overflowX: 'auto' }}>
        <div>
          {headerGroups.map((headerGroup) => (
            <div {...headerGroup.getHeaderGroupProps()} className="new-thead">
              {headerGroup.headers.map((column: any) => {
                return (
                  <div {...column.getHeaderProps()} className="header-cell new-th">
                    {column.render('Header')}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        <div {...getTableBodyProps()}>
          {rows?.map((row) => {
            prepareRow(row);
            return (
              <div {...row.getRowProps()} className="new-row" onClick={(): void => props.onRowClick(row.original)}>
                {row.cells.map((cell) => {
                  return (
                    <div {...cell.getCellProps()} className="body-cell new-td">
                      {cell.render('Cell')}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        {props.isLoading && <div className="d-flex align-self-center justify-content-center">Loading...</div>}
      </div>
      {props.rows?.length === 0 && <div className='text-center no-data-container'>
        <div><Icons.Data /></div>
        <p className="no-data-table">No data available in table.</p>
      </div>}
    </div>
  );
};
